import React from 'react';
import styled from 'styled-components';
import Button from './Button';
import { StyledInput } from './TextInput';
import { getPolicyFromIdpCode } from '../lib/auth';
import Loader from './Loader';
import VersionNum from './VersionNum';

const Container = styled.div`
    background-color: #2e2d2d;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const InnerContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-grow: 1;
`;

const InnerSubContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    transition: height 0.4s ease-in-out;
`;

const ExternalIdpToggle = styled.div`
    color: #ffffff;
    cursor: pointer;
    font-size: 15px;
    letter-spacing: 0.25px;
    line-height: 20px;
    margin-bottom: 32px;
    max-width: 90%;
    text-align: center;
    text-decoration: underline;
    width: 300px;
`;

const SignInButton = styled(Button)`
    border: 1px solid #fff;
    width: 300px;
    max-width: 90%;
    height: 60px;
    margin: auto;
    margin-top: 40px;
    font-weight: normal;
    font-size: 15px;
    letter-spacing: 0.25px;
    line-height: 20px;
`;

const ExternalIdpContainer = styled.div`
    max-width: 90%;
    width: 300px;
`;

const TextInputLabel = styled.div`
    color: white;
    font-size: 15px;
    letter-spacing: 0.25px;
    line-height: 20px;
    margin-bottom: 8px;
`;

const ErrorText = styled.div`
    color: #e04533;
    font-size: 15px;
    letter-spacing: 0.25px;
    line-height: 20px;
    margin-top: 8px;
`;

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showExternalIdpInput: false,
            externalIdpInputValue: '',
            error: props.error,
            loading: false
        };
    }

    render() {
        const toggleExternalIdp = () =>
            this.setState({
                showExternalIdpInput: !this.state.showExternalIdpInput,
                externalIdpInputValue: '',
                error: null,
                loading: false
            });

        const signIn = () => {
            this.setState({ error: null, loading: true });
            if (this.state.showExternalIdpInput) {
                getPolicyFromIdpCode(this.state.externalIdpInputValue).then(
                    policy => {
                        this.props.signIn(policy);
                    },
                    err => {
                        if (err.status === 400) {
                            this.setState({ error: 'Invalid identity provider code', loading: false });
                        } else {
                            this.setState({ error: 'An error occurred, please try again.', loading: false });
                        }
                    }
                );
            } else {
                this.props.signIn();
            }
        };

        return (
            <Container>
                <InnerContainer>
                    <InnerSubContainer>
                        {this.state.showExternalIdpInput && (
                            <ExternalIdpContainer>
                                <TextInputLabel>Your Organization's Identity Code</TextInputLabel>
                                <StyledInput
                                    style={{
                                        fontSize: '16px',
                                        height: '40px',
                                        border: this.state.error ? '1.5px solid #e04533' : null
                                    }}
                                    value={this.state.externalIdpInputValue}
                                    onChange={e => this.setState({ externalIdpInputValue: e.target.value })}
                                />
                            </ExternalIdpContainer>
                        )}
                        {this.state.error && <ErrorText>{this.state.error}</ErrorText>}
                        <SignInButton primary onClick={this.state.loading ? null : signIn}>
                            {this.state.loading ? (
                                <Loader type='small' />
                            ) : this.state.showExternalIdpInput ? (
                                'CONTINUE'
                            ) : (
                                'SIGN IN'
                            )}
                        </SignInButton>
                    </InnerSubContainer>
                </InnerContainer>
                <ExternalIdpToggle onClick={toggleExternalIdp}>
                    {this.state.showExternalIdpInput ? (
                        'Cancel'
                    ) : (
                        <div>
                            Sign In with Your Organization's
                            <br />
                            Identity Provider
                        </div>
                    )}
                </ExternalIdpToggle>
                <div style={{ width: '100%' }}>
                    <VersionNum color='#e3e3e3' />
                </div>
            </Container>
        );
    }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login.js